import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Calendar, AlertTriangle } from "lucide-react";

interface WeekendWarningDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onCancel?: () => void;
  date: string;
  type: 'attendance' | 'late';
}

export const WeekendWarningDialog = ({ 
  open, 
  onOpenChange, 
  onConfirm, 
  onCancel,
  date, 
  type 
}: WeekendWarningDialogProps) => {
  // تحويل التاريخ إلى يوم الأسبوع
  const getWeekdayName = (dateString: string) => {
    const date = new Date(dateString);
    const days = ['الأحد', 'الاثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'];
    return days[date.getDay()];
  };

  const weekday = getWeekdayName(date);
  const isAttendance = type === 'attendance';

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md" dir="rtl">
        <AlertDialogHeader className="bg-orange-50 -mx-6 -mt-6 px-6 pt-6 pb-4 rounded-t-lg">
          <AlertDialogTitle className="flex items-center gap-2 text-orange-600">
            <AlertTriangle className="h-5 w-5" />
            تنبيه - يوم إجازة
          </AlertDialogTitle>
        </AlertDialogHeader>
        <div className="-mx-6">
          <AlertDialogDescription className="space-y-3 text-gray-700 px-6">
            <div className="flex items-center gap-2 p-3 bg-orange-50 rounded-lg mx-0">
              <Calendar className="h-4 w-4 text-orange-600" />
              <span className="font-medium">
                اليوم المحدد هو يوم {weekday}
              </span>
            </div>
            
            <p className="text-sm text-right">
              {isAttendance 
                ? "هذا اليوم هو يوم إجازة رسمية. هل تريد تسجيل الحضور والغياب لهذا اليوم؟"
                : "هذا اليوم هو يوم إجازة رسمية. هل تريد تسجيل التأخر لهذا اليوم؟"
              }
            </p>
            
            <div className="text-xs text-gray-500 bg-gray-50 p-2 rounded text-right">
              <strong>ملاحظة:</strong> عادة لا يتم تسجيل {isAttendance ? 'الحضور' : 'التأخر'} في أيام الإجازة الرسمية (الجمعة والسبت).
            </div>
          </AlertDialogDescription>
          
          <AlertDialogFooter className="gap-2 mt-6 px-6">
            <AlertDialogCancel 
              onClick={() => {
                onCancel?.();
                onOpenChange(false);
              }}
              className="bg-gray-100 hover:bg-gray-200"
            >
              إلغاء
            </AlertDialogCancel>
            <AlertDialogAction 
              onClick={onConfirm}
              className="bg-orange-600 hover:bg-orange-700"
            >
              نعم، متابعة التسجيل
            </AlertDialogAction>
          </AlertDialogFooter>
        </div>
      </AlertDialogContent>
    </AlertDialog>
  );
};